/* Little Boudoir — carrousel de la mise en avant (haut de collection, 2 ou 3 produits).
   Les cartes sont empilées dans la même case (CSS) : on n'en montre qu'une, et on passe à la
   suivante toutes les N secondes (réglage de la section). Flèches ‹ ›, points, et glisser du
   doigt sur mobile pour changer à la main (le minuteur repart alors de zéro).
   Pause pendant le survol de la souris (on ne change pas la carte sous le curseur au moment du
   clic), au focus clavier et quand l'onglet est caché. Le défilement tourne aussi quand le
   système demande moins d'animations : la carte change alors sans fondu (CSS). Les cartes
   cachées sont inertes (ni clic ni tabulation). */
if (!customElements.get('lb-vedettes')) {
  customElements.define('lb-vedettes', class extends HTMLElement {
    connectedCallback() {
      this.diapos = Array.from(this.querySelectorAll('.lb-vedettes__diapo'));
      this.points = Array.from(this.querySelectorAll('.lb-vedettes__point'));
      if (this.diapos.length < 2) return;
      this.delai = Math.max(3, parseInt(this.dataset.delai, 10) || 5) * 1000;
      this.pauses = new Set();
      this.montrer(0);

      const aller = (i) => { this.montrer(i); this.relancer(); };
      this.points.forEach((p, i) => p.addEventListener('click', () => aller(i)));
      this.querySelectorAll('.lb-vedettes__fleche').forEach((b) => {
        b.addEventListener('click', (e) => { e.preventDefault(); aller(this.actuel + Number(b.dataset.sens)); });
      });

      /* glisser du doigt : au-delà de 40 px horizontaux, carte suivante / précédente */
      let x0 = null; let y0 = null;
      this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; const dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) aller(this.actuel + (dx < 0 ? 1 : -1));
      }, { passive: true });

      const pause = (raison) => () => { this.pauses.add(raison); this.arreter(); };
      const reprise = (raison) => () => { this.pauses.delete(raison); this.relancer(); };
      this.addEventListener('mouseenter', pause('survol'));
      this.addEventListener('mouseleave', reprise('survol'));
      this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) pause('focus')(); });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) reprise('focus')(); });
      this.onVisibilite = () => (document.hidden ? pause('onglet')() : reprise('onglet')());
      document.addEventListener('visibilitychange', this.onVisibilite);

      this.relancer();
    }
    disconnectedCallback() {
      this.arreter();
      if (this.onVisibilite) document.removeEventListener('visibilitychange', this.onVisibilite);
    }
    montrer(i) {
      this.actuel = (i + this.diapos.length) % this.diapos.length;
      this.diapos.forEach((d, j) => {
        const actif = j === this.actuel;
        d.classList.toggle('is-active', actif);
        d.inert = !actif;
        d.setAttribute('aria-hidden', String(!actif));
      });
      this.points.forEach((p, j) => p.setAttribute('aria-current', String(j === this.actuel)));
    }
    arreter() { clearInterval(this.minuterie); this.minuterie = null; }
    relancer() {
      this.arreter();
      if (this.pauses.size) return;
      this.minuterie = setInterval(() => this.montrer(this.actuel + 1), this.delai);
    }
  });
}
